module.exports = __webpack_public_path__ + "img/w3_circle_add_dark.1d4f3efb.png";